@if (!loading && sim && vista; as v) {
  <app-breadcrumb
    listado="/main/administracion/sims"
    etiquetaListado="SIMs"
    [titulo]="sim ? titulo : undefined"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>sim_card</mat-icon></div>
    <div class="encabezado-texto">
      <h1 class="sim-titulo">{{ titulo }}</h1>
      @if (subtitulo) {
        <span class="encabezado-nombre">{{ subtitulo }}</span>
      }
      <div class="encabezado-chips">
        <span
          [class]="'chip estado-' + v.estado.tono"
          [attr.title]="v.estado.detalle"
        >
          {{ v.estado.etiqueta }}
        </span>
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (service.puedeEditar()) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar SIM"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <section class="sim-info">
          <!-- Resumen: dónde está puesta. El estado y el cliente están en el
               encabezado. -->
          <app-dt-card>
            <app-dt-datos destacado>
              @for (e of v.equipos; track $index) {
                <app-dt-dato
                  [etiqueta]="
                    v.equipos.length > 1 ? 'Equipo ' + ($index + 1) : 'Equipo'
                  "
                  [valor]="e.nombre"
                >
                  @if (e.ruta || e.abrir) {
                    <button
                      irxBotonIcono
                      tamano="mini"
                      (click)="irA(e)"
                      tooltip="Ver detalle del equipo"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  }
                  @if (e.desde) {
                    <span class="dt-muted sim-fecha">
                      desde el {{ e.desde }}
                    </span>
                  }
                </app-dt-dato>
              } @empty {
                <app-dt-dato etiqueta="Equipo" valor="Sin asignar" />
              }
              <app-dt-dato
                etiqueta="ICCID informado por el equipo"
                [valor]="
                  v.iccidInformado ? 'hace ' + v.iccidInformado.hace : null
                "
              >
                @if (v.iccidInformado; as i) {
                  <span class="dt-muted sim-fecha">{{ i.fecha }}</span>
                }
              </app-dt-dato>
            </app-dt-datos>
          </app-dt-card>

          <div class="sim-grilla">
            <app-dt-card titulo="Datos de la SIM" icono="sim_card">
              <app-dt-datos>
                <app-dt-dato
                  etiqueta="ICCID"
                  [valor]="sim.iccid"
                  mono
                  copiable
                />
                <app-dt-dato
                  etiqueta="Número"
                  [valor]="sim.numero"
                  mono
                  copiable
                />
                <app-dt-dato etiqueta="IMSI" [valor]="sim.imsi" mono copiable />
                <app-dt-dato etiqueta="Operador" [valor]="sim.operador" />
              </app-dt-datos>
            </app-dt-card>

            <app-dt-card titulo="Conexión de datos" icono="cell_tower">
              <app-dt-datos>
                <app-dt-dato etiqueta="APN" [valor]="sim.apn" mono copiable />
                <app-dt-dato
                  etiqueta="Usuario"
                  [valor]="sim.usuario"
                  mono
                  copiable
                />
                <!-- Oculta hasta pedirla: no queda a la vista de cualquiera
                     que mire la pantalla -->
                <app-dt-dato
                  etiqueta="Contraseña"
                  [valor]="
                    sim.password
                      ? verPassword
                        ? sim.password
                        : '••••••••'
                      : null
                  "
                  mono
                >
                  @if (sim.password) {
                    <button
                      irxBotonIcono
                      tamano="mini"
                      (click)="verPassword = !verPassword"
                      [tooltip]="
                        verPassword
                          ? 'Ocultar contraseña'
                          : 'Mostrar contraseña'
                      "
                    >
                      <mat-icon>
                        {{ verPassword ? 'visibility_off' : 'visibility' }}
                      </mat-icon>
                    </button>
                  }
                </app-dt-dato>
              </app-dt-datos>
            </app-dt-card>
          </div>
        </section>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="sim._id"
          tipoEntidad="asignada"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else if (loading) {
  <app-detalle-esqueleto
    icono="sim_card"
    listado="/main/administracion/sims"
    etiquetaListado="SIMs"
    [pestanas]="2"
  ></app-detalle-esqueleto>
} @else {
  <!-- Sin breadcrumb no había cómo volver al listado -->
  <app-breadcrumb
    listado="/main/administracion/sims"
    etiquetaListado="SIMs"
    [titulo]="sim ? titulo : undefined"
  ></app-breadcrumb>
  <app-empty-state
    icon="sim_card"
    message="No se encontró la SIM."
  ></app-empty-state>
}
